import * as React from 'react';
import { ReactStripeElements } from 'react-stripe-elements';
export { ReactStripeElements } from 'react-stripe-elements';

export type InjectStripe = <P extends object>(
  WrappedComponent: React.ComponentType<
    P & ReactStripeElements.InjectedStripeProps
  >,
  componentOptions?: ReactStripeElements.InjectOptions
) => React.ComponentType<P>;

export type StripeComponentType = React.ComponentType<
  ReactStripeElements.ElementProps
>;
export type StripeElementsType = React.ComponentType<
  stripe.elements.ElementsCreateOptions
>;
export type StripeProviderType = React.ComponentType<
  ReactStripeElements.StripeProviderProps
>;

export type InstallStripe = () => Promise<stripe.StripeStatic>;

export const CardNumberElement: StripeComponentType =
  process.env.REACT_APP_NO_BACKEND === 'true'
    ? require('./StripeMock').CardNumberElement
    : require('react-stripe-elements').CardNumberElement;

export const CardExpiryElement: StripeComponentType =
  process.env.REACT_APP_NO_BACKEND === 'true'
    ? require('./StripeMock').CardExpiryElement
    : require('react-stripe-elements').CardExpiryElement;

export const CardCVCElement: StripeComponentType =
  process.env.REACT_APP_NO_BACKEND === 'true'
    ? require('./StripeMock').CardCVCElement
    : require('react-stripe-elements').CardCVCElement;

export const Elements: StripeElementsType =
  process.env.REACT_APP_NO_BACKEND === 'true'
    ? require('./StripeMock').Elements
    : require('react-stripe-elements').Elements;

export const StripeProvider: StripeProviderType =
  process.env.REACT_APP_NO_BACKEND === 'true'
    ? require('./StripeMock').StripeProvider
    : require('react-stripe-elements').StripeProvider;

export const injectStripe: InjectStripe =
  process.env.REACT_APP_NO_BACKEND === 'true'
    ? require('./StripeMock').injectStripe
    : require('react-stripe-elements').injectStripe;

let stripeInstall: Promise<stripe.StripeStatic>;
function _installStripe(): Promise<stripe.StripeStatic> {
  if (stripeInstall) {
    return stripeInstall;
  }

  stripeInstall = new Promise<stripe.StripeStatic>((resolve, reject) => {
    const script = document.createElement('script');

    script.addEventListener('load', () => resolve(window.Stripe));
    script.addEventListener('error', () => reject());

    script.src = 'https://js.stripe.com/v3/';
    document.body.appendChild(script);
  });

  return stripeInstall;
}

export const installStripe: InstallStripe =
  process.env.REACT_APP_NO_BACKEND === 'true'
    ? require('./StripeMock').installStripe
    : _installStripe;



// WEBPACK FOOTER //
// ./src/app/utils/Stripe/index.ts